// Constant domain ID for ReachThePeople — same across all environments.
// Eliminates the /domains API call that was failing for crawlers/bots
// without a domain param (LK-2604bo).
const REACHTHEPEOPLE_DOMAIN_ID = "67f67fe3e7020f5aa1fb302b";

const getDomainId = async () => {
  return REACHTHEPEOPLE_DOMAIN_ID;
};

const buildMegaPageLink = (item) => {
  return `/guides/${item.slug}`;
};

export { getDomainId, buildMegaPageLink };
